import React from 'react'

function Hello() {
  return (
    <div>
      {/* smsya ka samadha wala page login ke lie */}
    </div>
  )
}

export default Hello
